import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7fe413be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-navigation" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, " 课·视频 / 题·视频", -1))
const _hoisted_3 = { class: "cards-container" }
const _hoisted_4 = { class: "header" }
const _hoisted_5 = { class: "footer" }

import { useRouter } from 'vue-router'
import { ElCard } from 'element-plus/lib'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const router = useRouter()

// 定义导航菜单项
const menuItems = [
  {
    index: '1',
    label: '课例',
    route: '/course',
    description: '国家智慧中小学教育云平台（含精品课，国家课、教师备课）、北京空中课堂、部优精品课（先已合并到国家云平台）等小初高各学科资源，包含相关课件、教案、视频、学习任务单等配套资源的展示和下载。'
  },
  {
    index: '2',
    label: '试卷',
    route: '/paper',
    description: '本站收集和分享小初高各学科各年级期末考试和各地区统考试卷，中考高考学考模拟试卷和真题，不收集校级和教师日常试卷和练习卷。提供试卷解析和答案解析。'
  },
  {
    index: '3',
    label: '配图',
    route: '/paper-res',
    description: '提供试卷和教学使用的高质量配图资源，主要提供高清图片，高清地图、统计图等，Ai和Pdf矢量图为本站重点收集和展示的资源类型。'
  },
  {
    index: '4',
    label: '试题',
    route: '/question',
    description: '为方便老师们组卷和检索试题，本站对所有试卷试卷资源进行拆分、文本识别、校对，修订配套答案和解析。知识点归类整理（规划中，暂未实现）。'
  },
  {
    index: '5',
    label: '解析',
    route: '/resolve',
    description: '提供国家云平台、北京空中课堂、皖教云-资源专区、皖教云-活动评选、山东省优课资源-精品优课等课程资源的解析。根据官网资源链接提供解析后的资源名称和下载链接，通常包含视频、课件、教案（教学设计）、课后练习、学习任务单等。'
  },
  {
    index: '6',
    label: '会议',
    route: '/meeting',
    description: '提供教育行业会议的会议信息，可观看相关会议视频，可根据视频地址下载相关会议视频进行学习。视频会议多为国内知名学校先进的教育教学大型教育教学活动、公开课、家长会等。不定期更新，推荐学习。'
  }
]

// 导航函数
function navigate (route: string) {
  router.push(route)
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_text = _resolveComponent("el-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(menuItems, (item) => {
        return _createVNode(_unref(ElCard), {
          key: item.index,
          class: "nav-card",
          shadow: "hover"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h2", null, _toDisplayString(item.label), 1),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: ($event: any) => (navigate(item.route))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("前往")
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _createVNode(_component_el_divider),
            _createElementVNode("p", null, _toDisplayString(item.description), 1)
          ]),
          _: 2
        }, 1024)
      }), 64))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_el_text, null, {
        default: _withCtx(() => [
          _createTextVNode("本站资源来自网络公开免费资源。")
        ]),
        _: 1
      }),
      _createVNode(_component_el_text, null, {
        default: _withCtx(() => [
          _createTextVNode("本站只提供内容展示和免费分享。")
        ]),
        _: 1
      }),
      _createVNode(_component_el_text, null, {
        default: _withCtx(() => [
          _createTextVNode(" 如有侵权，联系站长处理。")
        ]),
        _: 1
      }),
      _createVNode(_component_el_text, null, {
        default: _withCtx(() => [
          _createTextVNode("更多需求可联系站长处理。")
        ]),
        _: 1
      })
    ])
  ]))
}
}

})